import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import { routerLinks } from "../../hoc/Router/routerLinks";
import { LEGAL_ENTITY_ADD } from "../../hoc/Router/routerTypes";
import LegalEntityAddForm from "../../components/LegalEntity/Add/LegalEntityAddForm";

const LegalEntityAddPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "افزودن فرد حقوقی ",
            to: routerLinks(LEGAL_ENTITY_ADD),
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <LegalEntityAddForm />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default LegalEntityAddPage;
